import {
  PRESCRIPTION_REGISTRATION_SORTS,
  type PrescriptionRegistrationSort,
  type RegistrationStatus,
} from '@/entities/prescription-registration/api/prescription-registration.api';
import { PAGE_SIZE_OPTIONS } from '@/shared/constants/pagination';
import {
  parseEnum,
  parsePageSize,
  parsePositiveInt,
  parsePositiveIntList,
  parseString,
  parseTrue,
  parseYear,
  parseYearMonth,
} from '@/shared/lib/searchParams';

/**
 * 07 처방 등록 현황 URL 상태 — 키 이름은 API(RDL-113)와 같다.
 * month·settlementMonth 가 없으면 /months 의 첫(가장 최근) 조합을 연다. detail*가 있으면 07-1 상세 패널이 열린다.
 * 담당자 필터는 다중 선택, 등록 상태는 하나(둘 다 = 전체 = 없음)다.
 */
export interface PrescriptionsSearch {
  /** 처방 등록 년도(yyyy). 없으면 month 의 년도, 그것도 없으면 올해 */
  year?: string;
  /** 처방 등록 월(yyyyMM). 없으면 그 해의 기본 조합(올해는 현재 월) */
  month?: string;
  /** 정산 월(yyyyMM). month 와 함께 /months 의 한 조합을 고른다 */
  settlementMonth?: string;
  keyword?: string;
  userIds?: number[];
  registrationStatus?: RegistrationStatus;
  pendingOnly?: true;
  /** 없으면 CLINIC_NAME(병의원명순) */
  sort?: PrescriptionRegistrationSort;
  page?: number;
  /** 보기 개수. 없으면 DEFAULT_VIEW_PAGE_SIZE */
  size?: number;
  detailUserId?: number;
  detailClinicId?: number;
}

export const validatePrescriptionsSearch = (
  search: Record<string, unknown>,
): PrescriptionsSearch => {
  return {
    // 고를 수 없는 조합이면 화면이 /months 의 첫 조합으로 연다
    year: parseYear(search.year),
    month: parseYearMonth(search.month),
    settlementMonth: parseYearMonth(search.settlementMonth),
    keyword: parseString(search.keyword),
    userIds: parsePositiveIntList(search.userIds),
    registrationStatus: parseEnum(search.registrationStatus, [
      'REGISTERED',
      'UNREGISTERED',
    ]),
    pendingOnly: parseTrue(search.pendingOnly),
    sort: parseEnum(search.sort, PRESCRIPTION_REGISTRATION_SORTS),
    page: parsePositiveInt(search.page),
    size: parsePageSize(search.size, PAGE_SIZE_OPTIONS),
    detailUserId: parsePositiveInt(search.detailUserId),
    detailClinicId: parsePositiveInt(search.detailClinicId),
  };
};
